export default function genRandomId(prefix, radix = 36) {
    return prefix + Math.random().toString(radix).substring(2);
}
